module.exports = __webpack_public_path__ + "img/cancel.c6ba33cc.svg";